module.exports = __webpack_public_path__ + "assets/1h30m.351364cc.svg";